import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/notarios/';

/**
 * GET Notarios
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getNotarios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Notario
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getNotario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Notario
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postNotario = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Notario
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchNotario = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Notario
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteNotario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Notario
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosNotario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Juegos de azar para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getNotariosCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/notario-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
